import React from "react";

const Input = ({
  value,
  onChange,
  placeholder,
  type = "text",
  disable = false,
  error = false,
  helperText,
}) => {
  return (
    <>
      <div
        className={`flex flex-col justify-start items-start h-[46px] w-full gap-2.5 px-4 py-3 rounded-lg border text-sm text-[#142b70]/80 placeholder:text-[#142b70]/50
        ${disable ? "text-[#eee] border-[#999]/30" : ""}
        ${error ? "border-red-500" : "border-[#a48572]/50"}
      `}
      >
        <div className="flex justify-start items-center w-full gap-1">
          <input
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disable}
            className={`w-full text-sm text-[#142b70] placeholder:text-[#142b70]/50 outline-none bg-transparent
            ${disable ? "text-[#999]" : ""}
          `}
          />
        </div>
      </div>
      {error && helperText && (
        <p className="text-xs text-red-600 mt-2">{helperText}</p>
      )}
    </>
  );
};

export default Input;
